module.exports = __webpack_public_path__ + "media/images/pc/visit_reservations_enpou/flow_04-3d265e0a87a7655948369c25e8db842f.jpg";